<template>
  <div class="gp-content">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'InsightsSection',
  computed: {
    tabs() {
      return [
        // {
        //   label: 'Insights',
        //   link: {
        //     name: 'insights.index',
        //   },
        //   icon: 'insight',
        // },
        {
          label: 'Configuration',
          link: {
            name: 'insights.config',
          },
          icon: 'preferences',
        },
      ];
    },
  },
  mounted() {
    this.SET_SECTION('Insights');
  },
  methods: {
    ...mapMutations(['SET_SECTION']),
  },
};
</script>
